import {
  GET_ALL_SALES,
  REFUND_SALE,
  RESET_SANTANDER_PAYMENT_QUERY,
  SEND_SANTANDER_ID,
} from '../types';

const initialState = {
  sales: [],
  refundSale: {},
  santanderPaymentQuery: null,
};

export default function Sales(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_SALES:
      return {
        ...state,
        sales: action.payload,
      };
    case REFUND_SALE:
      return {
        ...state,
        refundSale: action.payload,
      };
    case SEND_SANTANDER_ID:
      return {
        ...state,
        santanderPaymentQuery: action.payload,
      };
    case RESET_SANTANDER_PAYMENT_QUERY:
      return {
        ...state,
        santanderPaymentQuery: null,
      };
    default:
      return state;
  }
}
